import {CampaignsServiceModuleConfiguration} from "./CampaignsServiceModuleConfiguration";
import {CampaignActionLogServiceName, CampaignServiceName} from "../utils/names/serviceNames";
import {CampaignService} from "./service/CampaignService";
import {CampaignActionLogService} from "./service/CampaignActionLogService";

CampaignsServiceModuleConfiguration.createNewModule()
    .service(CampaignServiceName, CampaignService.instance)
    .service(CampaignActionLogServiceName, CampaignActionLogService.instance);